export const GATEWAY_URL = `https://${process.env.NEXT_PUBLIC_GWORLD_GATEWAY_DOMAIN_NAME}`;
export const GWORLD_URL = `https://${process.env.NEXT_PUBLIC_GWORLD_DOMAIN_NAME}`;
